import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class BrandingGrid extends BaseComponent {
	
	static get properties() {
		return {				
		};
	}
	
	constructor() {
		super();
		
		var brandingGrid = this;
		setTimeout(function(){
			brandingGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var brandingGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_BRANDING_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_BRANDING_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}				
				},
				{
					tag: 'dl-action-button',					
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_JOB_MANAGEMENT:WRITE'],
					style: 'width: 230px',
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemid: 'tools-copy',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:copy"></vaadin-icon> Copy',
								listeners: {
									click: function(event) {
										actionCopy(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'tools-activate',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:check"></vaadin-icon> Activate',
								listeners: {
									click: function(event) {
										actionActivate(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'tools-inactivate',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:minus"></vaadin-icon> InActivate',
								listeners: {
									click: function(event) {
										actionInActivate(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:rotate-right"></vaadin-icon> Reset to Default',
								listeners: {
									click: function(event) {
										actionReset(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:copy"></vaadin-icon> Copy Current Branding',
								listeners: {
									click: function(event) {
										actionCopy();
									}
								}
							}
						]
					}					
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					disabled: true,	
					permissions: ['ADMIN_BRANDING_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'brandingName',
					header: 'Name',
					'flex-grow': '1'
				},
				{						
					path: 'companyName',
					header: 'Company Name',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'companyType',
					header: 'Company Type',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'subSelectionStatus',
					header: 'Company Selection Status',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'activeStatus',
					header: 'Status',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					renderer: function(root, column, rowData) {	
						root.innerHTML = TimeUtil.formatDateStandard(TimeUtil.parseDate(rowData.item.updateDts));
					}
				},
				{
					path: 'updateUser',
					header: 'Update User',
					width: '7em'										
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
						if (ElementUtil.query(toolbar, 'tools-copy')) {
							ElementUtil.query(toolbar, 'tools-copy').disabled = false;
							
							ElementUtil.query(toolbar, 'tools-inactivate').disabled = true;
							ElementUtil.query(toolbar, 'tools-activate').disabled = true;
							if (item.activeStatus === 'A') {								
								ElementUtil.query(toolbar, 'tools-inactivate').disabled = false;
							} else {
								ElementUtil.query(toolbar, 'tools-activate').disabled = false;
							}							
						}
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
						if (ElementUtil.query(toolbar, 'tools-copy')) {
							ElementUtil.query(toolbar, 'tools-copy').disabled = true;
							ElementUtil.query(toolbar, 'tools-activate').disabled = true;
							ElementUtil.query(toolbar, 'tools-inactivate').disabled = true;
						}
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		brandingGrid.append(flexLayout);		
				
		var actionRefresh = function() {
			var loadMask = grid.showLoading();	
			Service.getBrandingService().getAllBranding().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;				
			});
		};
		actionRefresh();
		
 		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Branding',
				icon: 'vaadin:edit',
				listeners: {
					ready: function() {
						
						addEditWin.show();
						
						var colorInput = {
							tag: 'input',
							type: 'color',							
							listeners: {
								change: function(event) {
									event.target.title = event.target.value; 
								}
							}
						};
						
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'brandingName',
											required: true,
											maxlength: 120
										},	
										{
											tag: 'vaadin-combo-box',										
											label: 'Company',
											name: 'companyId',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getCompanyService().getCompaniesLookup().then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'						
										},	
										{
											tag: 'vaadin-combo-box',											
											label: 'Company Type',
											name: 'companyType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CompanyType').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Company Selection Status',
											name: 'subSelectionStatus',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function(combo) {
												var data = [
													{code: 'A', description: 'Active'},
													{code: 'I', description: 'Inactive'}
												];
												combo.items = data;												
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-text-field',
											label: 'Contact Email',
											name: 'contactEmail',											
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Contact Phone',
											name: 'contactPhone',											
											maxlength: 60
										},
										{
											tag: 'vaadin-text-field',
											label: 'Application Name',
											name: 'applicationName',											
											maxlength: 120
										},
										{
											tag: 'vaadin-text-field',
											label: 'Logo URL',
											name: 'logoURL',											
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Background URL',
											name: 'backgroundURL',											
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Login Title',
											name: 'loginTitle',											
											maxlength: 120
										},
										{
											tag: 'vaadin-text-field',
											label: 'Login Description',
											name: 'loginDescription',											
											maxlength: 1024
										},
										{
											tag: 'vaadin-text-field',
											label: 'Footer Company',
											name: 'footerCompany',											
											maxlength: 80
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Header Background Color',
											name: 'headerBackgroundColor',											
											maxlength: 60,											
											children: [
												Object.assign({title: record ? record.headerBackgroundColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Header Text Color',
											name: 'headerTextColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.headerTextColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Company Text Color',
											name: 'companyTextColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.companyTextColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Primary Background Color',
											name: 'primaryBackgroundColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.primaryBackgroundColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Primary Text Color',
											name: 'primaryTextColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.primaryTextColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Nav Background Color',
											name: 'navBackgroundColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.navBackgroundColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Nav Off Background Color',
											name: 'navOffBackgroundColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.navOffBackgroundColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Nav Text Color',
											name: 'navTextColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.navTextColor : ''}, colorInput)
											]
										},
										{
											tag: 'vaadin-custom-field',
											label: 'Menu Color',
											name: 'menuColor',											
											maxlength: 60,
											children: [
												Object.assign({title: record ? record.menuColor : ''}, colorInput)
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																														
															if (formPanel.isValid()) {
																
																var data = formPanel.getData();																																
																
																if (record) {
																	data.brandingId = record.brandingId;
																}
																
																if (data.companyId === '') {
																	delete data.companyId;
																}
																
																if (data.companyType === '') {
																	delete data.companyType;
																}
																
																if (data.subSelectionStatus === '') {
																	delete data.subSelectionStatus;
																}
																
																var loadMask = formPanel.showLoading('Saving...');
																Service.getBrandingService().saveBranding(data, record ? true : false).then(function(result){
																	loadMask.remove();
																	actionRefresh();
																	addEditWin.close();
																});																
																
															}	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							formPanel.load(record);							
						}
						
					}
				}
			});			
			
		};
		
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete <b>' + record.brandingName + '</b> branding?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting branding...');													
							
							Service.getBrandingService().deleteBranding(record.brandingId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted branding: ' + record.brandingName, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var actionCopy = function(record) {
			var loadMask = grid.showLoading();
						
			if (record) {			
				Service.getBrandingService().copyBranding(record).then(function(branding) {
					loadMask.remove();						
					actionRefresh();
				});
			} else {
				Service.getBrandingService().getCurrentBranding().then(function(defaultBranding){
					Service.getBrandingService().copyBranding(defaultBranding).then(function(defaultBranding) {
						loadMask.remove();						
						actionRefresh();
					});
				});
			}
			
		};
		
		var actionActivate = function(record) {
			var loadMask = grid.showLoading('Updating branding...');																				
			Service.getBrandingService().activateBranding(record.brandingId).then(function(){
				loadMask.remove();					
				window.location.reload(true);
			});	
		};
		
		var actionInActivate = function(record) {
			var loadMask = grid.showLoading('Updating branding...');																				
			Service.getBrandingService().inactivateBranding(record.brandingId).then(function(){
				loadMask.remove();					
				window.location.reload(true);
			});	
		};
		
		var actionReset = function() {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Reset',
				message: 'Are you sure you want to reset branding to default?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Resetting branding...');																				
							Service.getBrandingService().resetBranding().then(function(){
								loadMask.remove();					
								window.location.reload(true);
							});
						}	
					},
					{
						text: 'No'
					}
				]
			});				
			
		};
		
	}
	
};
customElements.define('dl-branding-grid', BrandingGrid);


